import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const boxSx = {
    backgroundColor: '#FFF',
    padding: '3px',
    zIndex: 100,
    width: '100px',
    position: 'absolute',
    top: '-225px',
    left: '22px',
    cursor: 'pointer'
};

const textSx = {
    fontSize: '9px',
    lineHeight: '12px',
    marginBottom: '2px',
    color: '#000'
};

const getBarSx = (value) => ({
    height: '8px',
    borderRadius: '3px',
    border: '1px solid #000',
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: '#FFF',
    },
    [`& .${linearProgressClasses.bar}`]: {
        backgroundColor: value < 20 ? '#FF0000' : value < 50 ? '#FF9623' : '#36DE36'
    },
});

const HealthBar = ({ value, name, sx, tooltipText, ...props }) => (
    <Tooltip title={tooltipText} placement="top">
        <Box sx={{ ...boxSx, ...sx }}>
            <Typography sx={textSx}>{name}</Typography>
            <LinearProgress sx={getBarSx(value)} value={value} {...props} variant="determinate" />
        </Box>
    </Tooltip>
);

export default HealthBar;